exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "\n.top__header {\n  display: none;\n  background: black;\n}\n.shop .top__header {\n    display: block;\n}\n.standalone .top__header {\n    display: block;\n}\n.top__header img {\n    margin: 1rem 2rem;\n    height: 2rem;\n}\n@media (max-width: 399px) {\n.top .title {\n    font-size: 0.7rem;\n}\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-compiler?{"id":"data-v-47fba948","scoped":false,"hasInlineConfig":true}!./~/sass-loader/lib/loader.js?indentedSyntax!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/top/TopComponent.vue
// module id = 151
// module chunks = 0